export default __webpack_public_path__ + "static/media/Top.2ab837eb.svg";